import { useQuery } from "@tanstack/react-query";
import orderApi from "../../../services/orderApi";
import { IOrderFilter } from "../../../interfaces/orderInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseOrdersQueryParams = {
  filter: IOrderFilter;
  pagination: IApiPagination;
};

export const useOrdersQuery = (params: UseOrdersQueryParams) => {
  return useQuery({
    queryKey: ["orders", params],
    queryFn: async () => {
      const res = await orderApi.getOrders(params.filter, params.pagination);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useOrderByIdQuery = (orderId?: string) => {
  return useQuery({
    queryKey: ["order-by-id", orderId],
    queryFn: async () => {
      const res = await orderApi.getOrder(orderId!);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
    enabled: !!orderId,
  });
};
